import { render, staticRenderFns } from "./CardMobile.vue?vue&type=template&id=01737502&scoped=true&"
import script from "./CardMobile.vue?vue&type=script&lang=js&"
export * from "./CardMobile.vue?vue&type=script&lang=js&"
import style0 from "./CardMobile.vue?vue&type=style&index=0&id=01737502&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01737502",
  null
  
)

component.options.__file = "CardMobile.vue"
export default component.exports